export const colors = {
  // Approved palette

  // Neutrals — dark to light
  black: '#000000',
  almostBlack: '#1D1D1F',
  menuGrey: '#454545',
  secLabel :'#6E6E73',
  borderGrey2: '#707070',
  noBookingText: '#808080',
  borderGrey: '#9F9F9F',
  helpBoxBorder:'#B9B7B7',
  profileBorder :'#C9C9C9',
  signInBorderColor: '#CECECE',
  borderGrey3: '#D0D0D0',
  checkOutTableTextColor: '#D5D5D5',
  accounMenuBorderColor: '#DFDFDF',
  lightGrey: '#E3E3E3',
  inputDisabled: '#EBEBEB',
  searchBarBackground: '#EFEFEF',
  white: '#FFFFFF',

  // Reds
  badge: '#E01E1E',
  red: '#FF0000',
  ltRed:   '#FFD6D6',
  errorRed: '#BF5252',

  // Oranges and yellows
  
  noWindow: '#FF8A00',
  passwordStrengthYellow: '#FFC500',
  checkOutCompleteScreenHighlight: '#E0E013',

  // Greens
  questionLinkText:'#339A14',
  setPhoneNumberBackground: '#3C8E63',
  optionBackground: '#2EAA69',
  questionBorder: '#87D99A',
  questionLinkBackground:'#DEF2E0',


  // Teals
  setPasswordBackground: '#044D4A',
  unsubscribeBackground: '#227989',
  tooltip: '#108AA7',
  backgroundGreen: '#4DA1B1',
  changeRoomTypeBackground: '#D5F8F2',

  // Blues
  forgotPasswordBackground: '#3C6684',
  hoverBlueClick: '#026CB0',
  hoverBlueNew: '#027BC7',
  iconBlue: '#056BD1',
  hoverBlue: '#038DE3',
  helpBoxBorderHover:'#3498DB',
  buttonDisabledColor: '#81909A',
  lightBlue: '#CCE8FA',
  hoverBlueDisabled: '#D6ECFA',


  // Transparent fills
  lightBlueTransp: 'rgba(204,232,250,0.25)',
  mobileBookingOverlay: 'rgba(0, 0, 0, 0.4)',

  // Shadows
  mobileBoxBookingShadow: 'rgba(0, 0, 0, 0.25)',
  accounMenuBorderShadowColor: 'rgba(0,0,0,0.16)',
  cardShadow: 'rgba(0,0,0,0.1)',
};
